module.exports = __webpack_public_path__ + "img/announcement.a3d3c565.svg";